import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AzureService {

  constructor(private readonly http: HttpClient) { }

  GetAzureDevopsActions(): any {
    return this.http.get(`${environment.apiUrl}/AzureDevops/GetAzureDevopsActions`);
  }

  /************************************/

  ListDevopsQueries(params: any): any {
    return this.http.get(`${environment.apiUrl}/AzureDevops/ListDevopsQueries`, { params });
  }
  SaveFolder(params: any): any {
    if (params.folderId) {
      return this.http.post(`${environment.apiUrl}/AzureDevops/RenameQueryFolder`, params);
    } else {
      return this.http.post(`${environment.apiUrl}/AzureDevops/CreateQueryFolder`, params);
    }
  }

  GetAzureDevopsQueryResult(params: any): any {
    return this.http.post(`${environment.apiUrl}/AzureDevops/GetAzureDevopsQueryResult`, params);
  }

  downloadQueryAsExcel(params: any): any {
    return this.http.post(`${environment.apiUrl}/AzureDevops/ExportAzureDevopsQueryResult`, params, {
      responseType: 'blob'
    });
  }

  ChangeWorkItemStatus(params: any): any {
    return this.http.post(`${environment.apiUrl}/AzureDevops/ChangeWorkItemStatus`, params);
  }
  GetWorkItemStatus(params: any): any {
    return this.http.get(`${environment.apiUrl}/AzureDevops/GetWorkItemStatus`, { params });
  }
  GetQueryConfigurations(params: any): any {
    return this.http.get(`${environment.apiUrl}/AzureDevops/GetQueryConfigurations`, { params });
  }
  GetWorkItemsFields(params: any): any {
    return this.http.get(`${environment.apiUrl}/AzureDevops/GetWorkItemsFields`, { params });
  }
  GetWorkItemsFieldsAllowedValues(params: any): any {
    return this.http.get(`${environment.apiUrl}/AzureDevops/GetWorkItemsFieldsAllowedValues`, { params });
  }

  RunQueryWithoutSave(params: any): any {
    return this.http.post(`${environment.apiUrl}/AzureDevops/RunQueryWithoutSave`, params);
  }
  SaveQuery(params: any): any {
    return this.http.post(`${environment.apiUrl}/AzureDevops/SaveQuery`, params);
  }
  GetQueryById(params: any): any {
    return this.http.get(`${environment.apiUrl}/AzureDevops/GetQueryById`, { params });
  }
  DeleteQuery(params: any): any {
    return this.http.delete(`${environment.apiUrl}/AzureDevops/DeleteQuery`, { params });
  }
  /************************************/

  MyReleases(): any {
    return this.http.get(`${environment.apiUrl}/AzureDevops/MyReleases`);
  }
  ListDevopsReleases(params: any): any {
    return this.http.get(`${environment.apiUrl}/AzureDevops/ListDevopsReleases`, { params });
  }

  /************************************/

  ListDevopsPiplines(params: any): any {
    return this.http.post(`${environment.apiUrl}/AzureDevops/ListDevopsPiplines`, params);
  }
  CancellePipeLine(params: any) {
    return this.http.get(`${environment.apiUrl}/AzureDevops/CancellePipeLine`, { params });
  }
  RunPipeLine(params: any) {
    return this.http.post(`${environment.apiUrl}/AzureDevops/RunPipeLine`, params);
  }
  GetBuildDetails(params: any): any {
    return this.http.get(`${environment.apiUrl}/AzureDevops/GetBuildDetails`, { params });
  }
  ListPipelineBuilds(params: any): any {
    return this.http.post(`${environment.apiUrl}/AzureDevops/ListPipelineBuilds`, params);
  }
  GetJobTasks(params: any): any {
    return this.http.get(`${environment.apiUrl}/AzureDevops/GetJobTasks`, { params });
  }
  GetTaskLog(params: any): any {
    return this.http.get(`${environment.apiUrl}/AzureDevops/GetTaskLog`, { params });
  }
}
